import { forwardRef, type Ref, type SVGProps } from "react";
const IconPanelLeftCloseOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M20.747 12.405a1 1 0 1 1 1.414 1.413L19.9 16.08l2.307 2.309a1 1 0 1 1-1.413 1.414l-3.016-3.016a1 1 0 0 1 0-1.414z" />
    <path
      fillRule="evenodd"
      d="M26.5 2.002c1.857-.067 3.423 1.275 3.499 3V28c-.079 1.073-.999 1.927-2.154 2H4.155C3 29.927 2.08 29.073 2.001 28V5.002c.076-1.725 1.642-3.067 3.5-3zm-21 2c-.663-.053-1.255.387-1.345 1V28h6.846V4.002zm21 0H13V28h14.844V5.002c-.09-.613-.682-1.053-1.346-1"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPanelLeftCloseOutlineSVG);
ForwardRef.displayName = "IconPanelLeftCloseOutline";
export { ForwardRef as IconPanelLeftCloseOutline };
